import React from 'react';
import { Link } from 'react-router-dom';
import NavigationLinks from './NavigationLinks';
import useNavigationHandler from '../hooks/useNavigationHandler';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
    const { handleLinkClick } = useNavigationHandler();
    const { t, language } = useLanguage();

    return (
        <footer id="mxd-footer" className="mxd-footer">
            <div className="mxd-footer__footer-blocks">
                <div className="footer-blocks__column animate-card-3">
                    <div className="footer-blocks__card fullheight-card">
                        <div className="footer-blocks__nav">
                            <ul className="footer-nav">
                                <NavigationLinks
                                    className="footer-nav__link btn-anim"
                                    wrapperClassName="footer-nav__item anim-uni-in-up"
                                    onLinkClick={handleLinkClick}
                                />
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer-blocks__column animate-card-3">
                    <div className="footer-blocks__card">
                        <div className="footer-blocks__message anim-uni-in-up">
                            <p className="footer-blocks__main-message">
                                {t('footer.message')}
                            </p>
                        </div>
                    </div>
                    <div className="footer-blocks__card">
                        <p className="mxd-point-subtitle anim-uni-in-up">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                <path fill="currentColor" d="M19.6,9.6c0,0-3,0-4,0c-0.4,0-1.8-0.2-1.8-0.2c-0.6-0.1-1.1-0.2-1.6-0.6c-0.5-0.3-0.9-0.8-1.2-1.2
                  c-0.3-0.4-0.4-0.9-0.5-1.4c0,0-0.1-1.1-0.2-1.5c-0.1-1.1,0-4.4,0-4.4C10.4,0.2,10.2,0,10,0S9.6,0.2,9.6,0.4c0,0,0.1,3.3,0,4.4
                  c0,0.4-0.2,1.5-0.2,1.5C9.4,6.7,9.2,7.2,9,7.6C8.7,8.1,8.2,8.5,7.8,8.9c-0.5,0.3-1,0.5-1.6,0.6c0,0-1.2,0.1-1.7,0.2
                  c-1,0.1-4.2,0-4.2,0C0.2,9.6,0,9.8,0,10c0,0.2,0.2,0.4,0.4,0.4c0,0,3.1-0.1,4.2,0c0.4,0,1.7,0.2,1.7,0.2c0.6,0.1,1.1,0.2,1.6,0.6
                  c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.5,0.5,1,0.6,1.6c0,0,0.1,1.3,0.2,1.7c0,1,0,4.1,0,4.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4
                  c0,0,0-3.1,0-4.1c0-0.4,0.2-1.7,0.2-1.7c0.1-0.6,0.2-1.1,0.6-1.6c0.3-0.4,0.7-0.8,1.1-1.1c0.5-0.3,1-0.5,1.6-0.6
                  c0,0,1.3-0.1,1.8-0.2c1,0,4,0,4,0c0.2,0,0.4-0.2,0.4-0.4C20,9.8,19.8,9.6,19.6,9.6L19.6,9.6z"></path>
                            </svg>
                            <a href="mailto:hi@3claus.com?subject=Mensaje%20desde%20tu%20sitio">hi@3claus.com</a>
                        </p>
                    </div>
                    <div className="footer-blocks__card">
                        <p className="mxd-point-subtitle anim-uni-in-up">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                <path fill="currentColor" d="M19.6,9.6c0,0-3,0-4,0c-0.4,0-1.8-0.2-1.8-0.2c-0.6-0.1-1.1-0.2-1.6-0.6c-0.5-0.3-0.9-0.8-1.2-1.2
                  c-0.3-0.4-0.4-0.9-0.5-1.4c0,0-0.1-1.1-0.2-1.5c-0.1-1.1,0-4.4,0-4.4C10.4,0.2,10.2,0,10,0S9.6,0.2,9.6,0.4c0,0,0.1,3.3,0,4.4
                  c0,0.4-0.2,1.5-0.2,1.5C9.4,6.7,9.2,7.2,9,7.6C8.7,8.1,8.2,8.5,7.8,8.9c-0.5,0.3-1,0.5-1.6,0.6c0,0-1.2,0.1-1.7,0.2
                  c-1,0.1-4.2,0-4.2,0C0.2,9.6,0,9.8,0,10c0,0.2,0.2,0.4,0.4,0.4c0,0,3.1-0.1,4.2,0c0.4,0,1.7,0.2,1.7,0.2c0.6,0.1,1.1,0.2,1.6,0.6
                  c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.5,0.5,1,0.6,1.6c0,0,0.1,1.3,0.2,1.7c0,1,0,4.1,0,4.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4
                  c0,0,0-3.1,0-4.1c0-0.4,0.2-1.7,0.2-1.7c0.1-0.6,0.2-1.1,0.6-1.6c0.3-0.4,0.7-0.8,1.1-1.1c0.5-0.3,1-0.5,1.6-0.6
                  c0,0,1.3-0.1,1.8-0.2c1,0,4,0,4,0c0.2,0,0.4-0.2,0.4-0.4C20,9.8,19.8,9.6,19.6,9.6L19.6,9.6z"></path>
                            </svg>
                            <a href="https://wa.me/34610683948" target="_blank" rel="noopener noreferrer">{t('footer.whatsapp')}</a>
                        </p>
                    </div>
                    <div className="footer-blocks__card">
                        <p className="mxd-point-subtitle anim-uni-in-up">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                <path fill="currentColor" d="M19.6,9.6c0,0-3,0-4,0c-0.4,0-1.8-0.2-1.8-0.2c-0.6-0.1-1.1-0.2-1.6-0.6c-0.5-0.3-0.9-0.8-1.2-1.2
                  c-0.3-0.4-0.4-0.9-0.5-1.4c0,0-0.1-1.1-0.2-1.5c-0.1-1.1,0-4.4,0-4.4C10.4,0.2,10.2,0,10,0S9.6,0.2,9.6,0.4c0,0,0.1,3.3,0,4.4
                  c0,0.4-0.2,1.5-0.2,1.5C9.4,6.7,9.2,7.2,9,7.6C8.7,8.1,8.2,8.5,7.8,8.9c-0.5,0.3-1,0.5-1.6,0.6c0,0-1.2,0.1-1.7,0.2
                  c-1,0.1-4.2,0-4.2,0C0.2,9.6,0,9.8,0,10c0,0.2,0.2,0.4,0.4,0.4c0,0,3.1-0.1,4.2,0c0.4,0,1.7,0.2,1.7,0.2c0.6,0.1,1.1,0.2,1.6,0.6
                  c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.5,0.5,1,0.6,1.6c0,0,0.1,1.3,0.2,1.7c0,1,0,4.1,0,4.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4
                  c0,0,0-3.1,0-4.1c0-0.4,0.2-1.7,0.2-1.7c0.1-0.6,0.2-1.1,0.6-1.6c0.3-0.4,0.7-0.8,1.1-1.1c0.5-0.3,1-0.5,1.6-0.6
                  c0,0,1.3-0.1,1.8-0.2c1,0,4,0,4,0c0.2,0,0.4-0.2,0.4-0.4C20,9.8,19.8,9.6,19.6,9.6L19.6,9.6z"></path>
                            </svg>
                            <span>C/ Lepant 270, Barcelona</span>
                        </p>
                    </div>
                </div>
                <div className="footer-blocks__column animate-card-3">
                    <div className="footer-blocks__card fullheight-card">
                        <div className="footer-blocks__block">
                            <div className="footer-blocks__title anim-uni-in-up">
                                <p className="footer-blocks__title-l">{t('footer.follow_us')}</p>
                            </div>
                            <div className="footer-blocks__socials">
                                <ul className="footer-socials">
                                    <li className="footer-socials__item anim-uni-in-up">
                                        <a href="https://www.instagram.com/som3claus/" className="footer-socials__link" target="_blank" rel="noopener noreferrer">@som3claus</a>
                                    </li>
                                    <li className="footer-socials__item anim-uni-in-up">
                                        <a href="https://www.linkedin.com/company/3claus" className="footer-socials__link" target="_blank" rel="noopener noreferrer">3claus</a>
                                    </li>
                                    <li className="footer-socials__item anim-uni-in-up">
                                        <Link
                                            to={`/${language}/blog`}
                                            className="footer-socials__link"
                                            onClick={handleLinkClick}
                                        >
                                            {t('blog.hero.title')}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer-blocks__links anim-uni-in-up">
                            <p className="t-xsmall t-muted">
                                <a className="no-effect" href="#" target="_blank" rel="noopener noreferrer">3claus</a>
                                <i className="ph-bold ph-copyright"></i>
                                2025
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
